var render = function render(_c,_vm){return _c('div',{staticClass:"vpage"},[_c('div',{staticClass:"vpage__top"},[_c('header',{staticClass:"vpage__header"},[_c('h1',{staticClass:"vpage__title"},[_vm._t("title")],2),_c('h3',{staticClass:"vpage__subtitle"},[_vm._t("subtitle")],2)]),_c('div',{staticClass:"vpage__info"},[_vm._t("info")],2)]),_c('div',{staticClass:"vpage__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }